// get function
$(document).ready(function () {
  window.favCurrentPage = 1;  
  window.favProductsLoaded = false;
  window.favBrandsLoaded = false;
  window.favOffersLoaded = false;
  window.currentFavType = "product";
  fetchResults(false);
});

// get faves json using handle
const faveStoreApi = {};

faveStoreApi.getProductByUrl = handle => {  
    return fetch("/products/" + handle + ".js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        }
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
    })
};

// get cart
faveStoreApi.getCartState = () =>
    fetch("/cart.js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    }).then(resp => resp.json());


  let inCartArr = [];
  faveStoreApi.getCartState().then(res => {
    for (let i = 0; i < res.items.length; i++) {
      inCartArr.push(res.items[i])
    }
  });

// removing a favorited item 
 const removeFave = (el, custId, id) => {
   let custIdStr = custId.toString();
   let idStr = id.toString().toLowerCase();
   //$(el).hide();//this prevents double clicks and removes the remove link
   
  customerFavorites(window.currentFavType,"remove",custIdStr,{"id":idStr})
  .then((result) => {
      if (result == "success")
      {
        $(el).closest(".fave-list-item-wrap").remove();
      }
      else
      {
        //something went wrong...prob show a message for them to try again. reload the results
        fetchResults(false);  
      }     
  })  
  .catch((err) => {
        console.log(err);
  });  
 }

// PRODUCTS
// compiling list of favorites from api result.data (faveArr)
const createFaveProductItem = async (faveArr) => {    
    let today = new Date().toLocaleDateString();
    let parseToday = Date.parse(today);
    // console.log('faveArr --> ', faveArr)
     if (faveArr.length === 0) {
      document.querySelector('.fave-list-container').insertAdjacentHTML('beforeend',
              `<div class="no-faves">You don't have any favorites yet.</div>
              <a href="/"><div class="fave-btn btn-primary">
                Start Shopping
              </div>
              </a>`)
     }
      let imageSize = "_335x";
      if (window.innerWidth < 768)
      {
        imageSize = "_200x";
      }
      let idarray = []; 
     // faveArr.forEach(({handle}) => {
     //     faveStoreApi.getProductByUrl(handle).then((item) => { 
     for (let i = 0; i < faveArr.length; i++) {
       
       await faveStoreApi.getProductByUrl(faveArr[i].handle).then((item) => {   
           
            let buttonSvg = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.124619 11.8743C0.205002 11.9548 0.314078 12 0.427819 12C0.54156 12 0.650636 11.9548 0.731019 11.8743L5.99791 6.60742L11.2669 11.8743C11.3753 11.9826 11.5331 12.0249 11.6811 11.9853C11.8291 11.9456 11.9447 11.8301 11.9843 11.6821C12.024 11.5341 11.9817 11.3762 11.8733 11.2679L6.60431 6.00102L11.8712 0.731989C12.0386 0.564536 12.0386 0.293042 11.8712 0.125589C11.7037 -0.0418632 11.4323 -0.0418632 11.2648 0.125589L5.99791 5.39462L0.728876 0.127732C0.558844 -0.0178794 0.305385 -0.0080894 0.147091 0.150204C-0.0112021 0.308497 -0.0209922 0.561957 0.124619 0.731989L5.39151 6.00102L0.124619 11.2701C-0.0415398 11.4372 -0.0415398 11.7072 0.124619 11.8743Z" fill="black"/></svg> </button>`;
            let customerId = customerIDFave; 
           
            if (typeof item != "undefined") {
              let productId = faveArr[i].productId;
              idarray.push(productId);
              let link = `href="/products/${faveArr[i].handle}"`
              
              // let comparePrice = (item.compare_at_price / 100.0).toFixed(2);
              let price;
              let priceStr;
              let imageUrl;

              if (item.variants.length > 1) {
                price = item.variants[0].price;
                imageUrl = item.variants[0].featured_image.src;
                for (let j=0;j<item.variants.length;j++)
                {
                  if (item.variants[j].price < price && item?.variants[j]?.featured_image && item.variants[j].available == true)
                  {
                    price = item.variants[j].price;
                    imageUrl = item.variants[j].featured_image.src;
                  }
                }
              } else {
                price = item.variants[0].price;
                imageUrl = item.variants[0]?.featured_image.src;
              }
              // Fall back to regular image if no variant image
              imageUrl = imageUrl || item.images[0];
              //load smaller images, otherwise they are 2000x2000
              imageUrl = imageUrl.replace(/(\.[^.]*)$/,imageSize+"$1");
              
              let luxe = ""
              if (item.tags.includes("brand-type_1")) {
                luxe = '<div class="fave-luxe"><svg width="37" height="12" viewBox="0 0 37 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99723 11.7839V10.8033H1.04709V0H0V11.7839H6.99723ZM12.5152 12C14.9252 12 16.554 10.5374 16.554 7.8615V0H15.5069V7.81164C15.5069 9.8892 14.4598 11.036 12.5152 11.036C10.5706 11.036 9.52355 9.8892 9.52355 7.81164V0H8.47645V7.8615C8.47645 10.554 10.1219 12 12.5152 12ZM19.4792 11.7839L22.8366 6.71468L26.1607 11.7839H27.4072L23.4515 5.86704L27.4238 0H26.1773L22.8532 5.05263L19.5457 0H18.2825L22.2382 5.86704L18.2493 11.7839H19.4792ZM36.3158 11.7839V10.8199H30.4155V6.36565H35.8006V5.40166H30.4155V0.963989H36.3158V0H29.3684V11.7839H36.3158Z" fill="black"/></svg></div>';
              } else {
                delete luxe;
              }

              price = (price / 100.0).toFixed(2)
              priceStr = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              let comparePrice = "";
              let comparePriceStr = "";
              let discount = "";
              let comparePriceNum = (item.compare_at_price / 100.0).toFixed(2);
              let numberComparePrice = Number(comparePriceNum);
              let numberPrice = Number(price);

              if (numberComparePrice > numberPrice) {
                comparePriceStr = "$"+comparePriceNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                comparePrice = "$"+comparePriceNum
                discount = Math.round(((comparePriceNum - price) * 100) / comparePriceNum) + '%';
              } else {
                comparePriceStr = "";
                discount = "";
              }
                                     
              //let deal = "";
              // for (let k = 0; k < item.tags.length; k++) {
                
              //   if (item.tags[k].includes("promo_")) {
                  
              //     let tag = item.tags[k];
              //     dealArray = tag.split("_");
              //     let promoStart = Date.parse(dealArray[2])
              //     let promoEnd = Date.parse(dealArray[3])
              //     if (parseToday >= promoStart && parseToday < promoEnd) {
              //       deal = dealArray[1];
              //       console.log(productId);
              //     }
              //   } else {
              //      // delete deal;
              //   }
              // }

              let preOwned = "";
              for (let j = 0; j < item.tags.length; j++) {
                if (item.tags[j].includes("product-condition_Preowned")) {
                  let tag = item.tags[j];
                  comparePriceStr = "";
                  discount = "";
                  preOwned = '<div class="preownedbadge2">PRELOVED</div>';
                  break;
                } else {
                  delete preOwned;
                }
              }

              let finalSale = "";
              if (item.tags.includes("NotReturnable")) {
                finalSale = '<div class="finalsalebadge2">FINAL SALE</div>';
              } else {
                delete finalSale;
              }              

              let soldOut = "";
              if (item.available === false) {
                soldOut = `<div class="fave-soldout-wrap"><div class="fave-soldout">SOLD OUT</div><div class="fave-sold-rem" onclick="removeFave(this, ${customerId}, ${productId})">Remove</div></div>`
              } else {
                delete soldOut;
              }        

              let cart = "";
              if (inCartArr.length === 0 && item.available) {
                // add to bag
                cart = `<a href="/products/${faveArr[i].handle}"><div class="fave-cart-wrap"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.32011 0.0488281H4.73911C3.91036 0.0488281 3.22186 0.724578 3.22186 1.56608V2.11433H1.24561C1.11811 2.11433 1.01611 2.21633 1.01611 2.34383V2.35658L1.33486 8.96108C1.37311 9.86633 2.12536 10.5803 3.03061 10.5803H6.68986C7.17436 11.7151 8.48761 12.2378 9.62236 11.7533C10.7571 11.2688 11.2799 9.95558 10.7954 8.82083C10.5914 8.34908 10.2344 7.95383 9.77536 7.72433L10.0304 2.35658C10.0304 2.22908 9.92836 2.12708 9.81361 2.12708H7.82461V1.57883C7.82461 0.724578 7.14886 0.0488281 6.32011 0.0488281ZM3.68086 1.55333C3.68086 0.966828 4.15261 0.482328 4.75186 0.482328H6.33286C6.91936 0.482328 7.40386 0.954078 7.40386 1.55333V2.10158H3.68086V1.55333ZM10.3874 10.4018C10.1069 11.0521 9.45661 11.4728 8.75536 11.4728C7.99036 11.4728 7.31461 10.9883 7.05961 10.2743C6.99586 10.0831 6.95761 9.89183 6.95761 9.68783C6.95761 8.70608 7.76086 7.90283 8.74261 7.90283C10.0176 7.89008 10.8974 9.20333 10.3874 10.4018ZM9.58411 2.54783L9.34186 7.53308C8.15611 7.20158 6.93211 7.89008 6.60061 9.07583C6.51136 9.42008 6.48586 9.77708 6.56236 10.1213H3.04336C2.38036 10.1213 1.81936 9.59858 1.79386 8.93558L1.48786 2.56058H3.23461V3.31283C3.23461 3.44033 3.33661 3.54233 3.46411 3.54233C3.59161 3.54233 3.69361 3.44033 3.69361 3.31283V2.56058H7.40386V3.31283C7.40386 3.44033 7.50586 3.54233 7.63336 3.54233C7.76086 3.54233 7.86286 3.44033 7.86286 3.31283V2.56058H9.58411V2.54783Z" fill="black"/><path d="M8.7424 8.50208C8.6149 8.50208 8.5129 8.60408 8.5129 8.73158V9.45833H7.78614C7.65864 9.45833 7.55664 9.56033 7.55664 9.68783C7.55664 9.81533 7.65864 9.91733 7.78614 9.91733H8.5129V10.6441C8.5129 10.7716 8.6149 10.8736 8.7424 10.8736C8.8699 10.8736 8.9719 10.7716 8.9719 10.6441V9.91733H9.69865C9.82615 9.91733 9.92815 9.81533 9.92815 9.68783C9.92815 9.56033 9.82615 9.45833 9.69865 9.45833H8.9719V8.73158C8.9719 8.60408 8.8699 8.50208 8.7424 8.50208Z" fill="black"/></svg><div class="fave-cart-copy">Add to Bag</div></div></a>`               
              } else {
                for (let j = 0; j < inCartArr.length; j++) {
                  if (inCartArr[j].handle != faveArr[i].handle && item.available) {
                    // add to bag
                    cart = `<a href="/products/${faveArr[i].handle}"><div class="fave-cart-wrap"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.32011 0.0488281H4.73911C3.91036 0.0488281 3.22186 0.724578 3.22186 1.56608V2.11433H1.24561C1.11811 2.11433 1.01611 2.21633 1.01611 2.34383V2.35658L1.33486 8.96108C1.37311 9.86633 2.12536 10.5803 3.03061 10.5803H6.68986C7.17436 11.7151 8.48761 12.2378 9.62236 11.7533C10.7571 11.2688 11.2799 9.95558 10.7954 8.82083C10.5914 8.34908 10.2344 7.95383 9.77536 7.72433L10.0304 2.35658C10.0304 2.22908 9.92836 2.12708 9.81361 2.12708H7.82461V1.57883C7.82461 0.724578 7.14886 0.0488281 6.32011 0.0488281ZM3.68086 1.55333C3.68086 0.966828 4.15261 0.482328 4.75186 0.482328H6.33286C6.91936 0.482328 7.40386 0.954078 7.40386 1.55333V2.10158H3.68086V1.55333ZM10.3874 10.4018C10.1069 11.0521 9.45661 11.4728 8.75536 11.4728C7.99036 11.4728 7.31461 10.9883 7.05961 10.2743C6.99586 10.0831 6.95761 9.89183 6.95761 9.68783C6.95761 8.70608 7.76086 7.90283 8.74261 7.90283C10.0176 7.89008 10.8974 9.20333 10.3874 10.4018ZM9.58411 2.54783L9.34186 7.53308C8.15611 7.20158 6.93211 7.89008 6.60061 9.07583C6.51136 9.42008 6.48586 9.77708 6.56236 10.1213H3.04336C2.38036 10.1213 1.81936 9.59858 1.79386 8.93558L1.48786 2.56058H3.23461V3.31283C3.23461 3.44033 3.33661 3.54233 3.46411 3.54233C3.59161 3.54233 3.69361 3.44033 3.69361 3.31283V2.56058H7.40386V3.31283C7.40386 3.44033 7.50586 3.54233 7.63336 3.54233C7.76086 3.54233 7.86286 3.44033 7.86286 3.31283V2.56058H9.58411V2.54783Z" fill="black"/><path d="M8.7424 8.50208C8.6149 8.50208 8.5129 8.60408 8.5129 8.73158V9.45833H7.78614C7.65864 9.45833 7.55664 9.56033 7.55664 9.68783C7.55664 9.81533 7.65864 9.91733 7.78614 9.91733H8.5129V10.6441C8.5129 10.7716 8.6149 10.8736 8.7424 10.8736C8.8699 10.8736 8.9719 10.7716 8.9719 10.6441V9.91733H9.69865C9.82615 9.91733 9.92815 9.81533 9.92815 9.68783C9.92815 9.56033 9.82615 9.45833 9.69865 9.45833H8.9719V8.73158C8.9719 8.60408 8.8699 8.50208 8.7424 8.50208Z" fill="black"/></svg><div class="fave-cart-copy">Add to Bag</div></div></a>`
                  }
                }
                for (let j = 0; j < inCartArr.length; j++) {
                  if (inCartArr[j].handle === faveArr[i].handle && item.available) {
                    // in your bag
                    cart = '<div class="fave-cart-wrap"><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.8896 0.339184C11.7582 0.225489 11.5592 0.240653 11.4443 0.373285L4.08708 8.9564L0.538901 5.40822C0.415738 5.28505 0.215536 5.28505 0.0923725 5.40822C-0.0307908 5.53138 -0.0307908 5.73158 0.0923725 5.85474L3.88182 9.64419C3.94119 9.70293 4.02202 9.73639 4.10539 9.73639C4.10919 9.73639 4.11359 9.73639 4.11802 9.73703C4.20582 9.73323 4.28855 9.69282 4.34539 9.6265L11.9243 0.784447C12.0374 0.651815 12.0222 0.452855 11.8896 0.339184Z" fill="black"/></svg><div class="fave-cart-copy">In your Bag</div></div>'
                  }
                }
              }
              
            document.querySelector('.fave-list-container').insertAdjacentHTML('beforeend',
              `<div class="fave-list-item-wrap" style="list-style-type: none;" id="fave-item-${productId}">
              <div class="fave-list-item">
                <a ${link}>
                  <div class="fave-item-img-wrap">
                    <div class="fave-image-mask"></div>
                    <img class="fave-image lazyload" data-src="${imageUrl}"/>   
                    ${luxe}
                  </div>
                </a>
                <div class="fave-item-copy-wrap">
                  <div class="fave-item-copy-top">
                      <div class="fave-item-title">
                        ${item.title}
                      </div>
                      <div class="fave-deal" id="deal-${productId}">                        
                      </div>
                      <div class="fave-price-wrap">
                        <div class="fave-item-price">
                          $${priceStr}
                        </div>
                        <div class="fave-item-compare">
                          ${comparePriceStr}
                        </div>
                        <div class="fave-item-discount">
                          ${discount}
                        </div>
                      </div>
                      <div class="fave-pre-final-wrap">
                        ${preOwned}
                        ${finalSale}
                      </div>
                  </div>
                  <div class="fave-item-copy-bottom">
                      ${soldOut}
                      ${cart}
                  </div>
                </div>
                <div class="faveRemoveBtn" onclick="removeFave(this, ${customerId}, ${productId})">${buttonSvg}</div>
              </div>
              <div class="fave-break"></div>
              </div>
              `)       
            } else {
              let titleOld = faveArr[i].handle.split("-").join(' ');
              let title = titleOld.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
              let prodId = faveArr[i].productId;
              
              document.querySelector('.fave-list-container').insertAdjacentHTML('beforeend',
              `<div class="fave-list-item-wrap" style="list-style-type: none;">
              <div class="fave-list-item">
                  <div class="fave-item-img-wrap">
                    <svg width="140" height="175" viewBox="0 0 140 175" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="140" height="175" fill="#F7F7F7"/>
                      <path d="M87 68H54C52.3432 68 51 69.3432 51 71V104C51 105.657 52.3432 107 54 107H87C88.6568 107 90 105.657 90 104V71C90 69.3432 88.6568 68 87 68ZM87 104H54V71H87V104Z" fill="#BDBDBD"/>
                      <path d="M58.4999 96.5H82.4999C83.3283 96.5048 84.0038 95.8372 84.0086 95.0087C84.011 94.6057 83.8511 94.2188 83.5649 93.935L77.5649 87.935C76.9798 87.3534 76.035 87.3534 75.4499 87.935L73.4999 89.885L68.5649 84.95C67.9798 84.3684 67.035 84.3684 66.4499 84.95L57.4499 93.95C56.87 94.5416 56.8793 95.4913 57.4708 96.0712C57.7461 96.341 58.1145 96.4946 58.4999 96.5Z" fill="#BDBDBD"/>
                      <path d="M78 84.5C79.6569 84.5 81 83.1569 81 81.5C81 79.8431 79.6569 78.5 78 78.5C76.3431 78.5 75 79.8431 75 81.5C75 83.1569 76.3431 84.5 78 84.5Z" fill="#BDBDBD"/>
                    </svg>
                  </div>
                  <div class="fave-item-copy-wrap">
                    <div class="fave-item-copy-top">
                        <div class="fave-item-title">
                          ${title}
                        </div>
                    </div>
                    <div class="fave-soldout-wrap">
                      <div class="fave-item-unavil fave-soldout">No longer available</div>
                      <div class="fave-sold-rem" onclick="removeFave(this, ${customerId}, ${prodId})">Remove</div>
                    </div>
                  </div>
                  <div class="faveRemoveBtn" onclick="removeFave(this, ${customerId}, ${prodId})">${buttonSvg}</div>
              </div>
              <div class="fave-break"></div>
              </div>
              `)
            }           
           })
           .catch((err) => {
             console.log(err);
            }
           )         
      } // end of for each    
      //promos
      //console.log(idarray);
      fetch(`https://spo-partner-api.azure-api.net/search?Subscription-Key=662cff71ce7d49088924abf032a0785c&searchFields=ProductID&selectFields=ProductID,activePromo,Promos&suppressFacets=true&term=${idarray.join('%7C')}`)
    .then(response => response.json())
    .then(data => {
      let nowLocalTime = new Date();
      for (let p=0;p<data.value.length;p++)
      {
          let hasActivePromo = false;
          if (data.value[p].activePromo && !data.value[p].activePromo.code.toLowerCase().startsWith("app"))
          {
            let pStart = new Date(data.value[p].activePromo.startDate);
            let pEnd = new Date(data.value[p].activePromo.endDate);
            if (nowLocalTime >= pStart && nowLocalTime < pEnd)   
            {               
              let cv = "";
              if (data.value[p].activePromo.discountType == "percentage")
              {
                  cv = data.value[p].activePromo.discountValue + "%";
              }
              else
              {
                  cv = "$" + data.value[p].activePromo.discountValue;
              }
              let h = `Extra ${cv} Off with Code: ${data.value[p].activePromo.code}`;
              $("#deal-" + data.value[p].ProductID).html(h);
              //console.log(cv);
              hasActivePromo = true;
            }
          }
          if (!hasActivePromo)
          {
            for(let v=0;v<data.value[p].Promos.length;v++)
            {
              if (true)
              {          
                let promo = data.value[p].Promos[v];
                let code = promo.discountCode;
                let startD = new Date(promo.StartDate);
                let endD = new Date(promo.EndDate);
                if (nowLocalTime >= startD && nowLocalTime < endD) 
                {          
                  if (code && code.toLowerCase().startsWith("app"))
                  {
                    break;
                  }
                  else
                  {
                    let h = `${promo.Text}`;
                    $("#deal-" + data.value[p].ProductID).html(h);
                  }                  
                  break;
                }
              }
            }
          }
      }
    }); 
}; 

// BRANDS
const createFaveBrandItem = async (faveArr) => 
{      
    let today = new Date().toLocaleDateString();
    let parseToday = Date.parse(today);
    let buttonSvg = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.124619 11.8743C0.205002 11.9548 0.314078 12 0.427819 12C0.54156 12 0.650636 11.9548 0.731019 11.8743L5.99791 6.60742L11.2669 11.8743C11.3753 11.9826 11.5331 12.0249 11.6811 11.9853C11.8291 11.9456 11.9447 11.8301 11.9843 11.6821C12.024 11.5341 11.9817 11.3762 11.8733 11.2679L6.60431 6.00102L11.8712 0.731989C12.0386 0.564536 12.0386 0.293042 11.8712 0.125589C11.7037 -0.0418632 11.4323 -0.0418632 11.2648 0.125589L5.99791 5.39462L0.728876 0.127732C0.558844 -0.0178794 0.305385 -0.0080894 0.147091 0.150204C-0.0112021 0.308497 -0.0209922 0.561957 0.124619 0.731989L5.39151 6.00102L0.124619 11.2701C-0.0415398 11.4372 -0.0415398 11.7072 0.124619 11.8743Z" fill="black"/></svg> </button>`;
     if (faveArr.length === 0) 
     {
      document.querySelector('.fave-brand-list-container').insertAdjacentHTML('beforeend',
              `<div class="no-faves">You don't have any favorite brands yet.</div>
              <a href="/pages/brands"><div class="fave-btn btn-primary">
                Find Brands
              </div>
              </a>`)
     }
     else
     {
       //{brandId: '1,state', originalName: '1.State', timestamp: '2023-06-14T13:23:51.363Z'}

       /* <a class="fave-list-item-brand" href="/collections/all?Brand=${faveArr[i].originalName}">${faveArr[i].originalName}</a> 
       <div class="faveRemoveBtn" onclick="removeFave(this, ${customerIDFave}, '${faveArr[i].brandId}')">${buttonSvg}</div> */
       faveArr.sort(function(a, b) {
           return a.originalName.localeCompare(b.brandId);
        });
       for (let i = 0; i < faveArr.length; i++) 
       {
         let origName = faveArr[i].originalName.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
         let handleName = faveArr[i].originalName;
          document.querySelector('.fave-brand-list-container').insertAdjacentHTML('beforeend',
            `<div class="fave-list-item-wrap" style="list-style-type: none;">
            <div class="fave-list-item">
                <svg class="fave-list-item-heart" onclick='removeFave(this, ${customerIDFave}, "${handleName.replace(/'/g, '&apos;')}")' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.9736 4.99772C15.74 2.42711 13.9205 0.562075 11.6435 0.562075C10.1265 0.562075 8.73748 1.37843 7.95589 2.68681C7.18139 1.36151 5.84931 0.561768 4.35661 0.561768C2.07986 0.561768 0.260064 2.4268 0.02682 4.99741C0.00835741 5.11095 -0.0673393 5.70853 0.162828 6.68304C0.494539 8.08866 1.26074 9.3672 2.37803 10.3796L7.9522 15.438L13.6221 10.3799C14.7394 9.3672 15.5056 8.08897 15.8373 6.68304C16.0674 5.70883 15.9917 5.11126 15.9736 4.99772Z" fill="black"/>
                </svg>
                <a class="fave-list-item-brand" href="/collections/all?Brand=${encodeURIComponent(handleName)}&allBrands=1">${origName}</a> 
            </div>
            <div class="fave-brand-break"></div>
            </div>
            `);
       } // end of for each   
     }
}; 

function doFavPaging(current, { range, pages, start = 1 }) {
  let paging = [];
  if (range > pages)
    range = pages;
  var i = Math.min(pages + start - range, Math.max(start, current - (range / 2 | 0)));
  let end = i + range;
  while (i < end) { paging.push(i === current ? `<li><a onclick="favPageClick(${i})" class="favPagerCurrentPage">${i}</a></li>` : `<li><a onclick="favPageClick(${i})">${i}</a></li>`); i++; }
  return paging;
}
function favPageClick(page)
{
  window.favCurrentPage = page;
  fetchResults(false);
  window.scrollTo(0, 1);
}
function changeCenter(e)
{
  if (e.value != "0"){
    let o = {"id": e.value};
    getOfferFaves(o); 
  }    
}
function fetchResults(isRemove)
{
  if (window.currentFavType == "offers")
  {
    $("#fave-offer-list").html("");
  $(".fave-offers-list-container").html(`<div class="favesLoaderparent"><div class='favesloader'></div></div>`);
    window.simonPlus.get('/users')
    .then((data) => {
      let faveCenter = {};
      if (data.jsonBody.centerFavorites && data.jsonBody.centerFavorites.length > 0)
      {
        faveCenter = data.jsonBody.centerFavorites[0];
      }
      //console.log(data);
      if (data.jsonBody)
      {
        if ($("#centers").length == 0)
        {
          window.simonPlus.get('/centers','pagesize=500')
          .then((data) => {
            //console.log(data);
            let html = ``;
            let s = `Available at <select onchange="changeCenter(this)" id="faveCenterDrop" class="centerSelect"><option value="0">Select a Center</option>`;
            for (let x=0;x<data.jsonBody.results.length;x++)
            {
              s+=`<option value="${data.jsonBody.results[x].id}">${data.jsonBody.results[x].name}</option>`;
            }
            s += `</select><div id="fave-offer-list"></div>`;
            html+=s;
            $("#fave-offers-list-container").html(html).show();
            if (faveCenter.name)
            {
              //$("#faveCenterDrop").after("<div>keelo</div>");
              $("#faveCenterDrop").val(faveCenter.id);
              getOfferFaves(faveCenter);              
            }
            
          });      
        } 
        // let favhtml = "";
        // if (data.jsonBody.centerFavorites && data.jsonBody.centerFavorites.length > 0)
        // {
        //   favhtml = data.jsonBody.centerFavorites[0].name;
        // }
        // else
        // {
         
        // }
        // let html = `<div style="display:flex;flex-wrap: wrap;">Available at ${}</div>`;
        // $("#fave-offers-list-container").html(html).show();
      }
    });     
  }
  else
  {
     customerFavorites(window.currentFavType,"get",customerIDFave,{})
    .then((result) => {
        if (window.currentFavType == "product")
        {
          $(".fave-list-container").html("");
          window.favProductsLoaded = true;
        }
        else if (window.currentFavType == "brand")
        {
          $(".fave-brand-list-container").html("");
          window.favBrandsLoaded = true;
        }        
        favDraw(result,isRemove); 
    }).catch((err) => {
        console.log(err);}); 
  }  
}
function getOfferFaves(c)
{
  $("#fave-offer-list").html(`<div class="favesLoaderparent"><div class='favesloader'></div></div>`);
 // $(".fave-list-container").html(``);
  //$(".fave-list-container").html(`<div class="favesLoaderparent"><div class='favesloader'></div></div>`);
      window.favOffersLoaded = true;
      //console.log("calling offers api");
      window.simonPlus.get(`/users/favorites/exclusive-offers`,`page=1&pagesize=500&centerid=${c.id}`)
      .then((data) => {
        //console.log(data);     
        //console.log("done calling offers api");
        let offerURL = "https://plus.simon.com/account/exclusive-offers/";
        let offerURL2 = "https://plus.simon.com/account/exclusive-offers/";
        if (location.href.indexOf("sspotest") > -1)
        {
          offerURL = "https://plus.simon-ops.com/account/exclusive-offers/";
        }
        if (data.jsonBody && data.jsonBody.results.length > 0)
        {
          $(".fave-list-container").html(``);
          let html = `<div style="display:flex;flex-wrap: wrap;padding-top:20px">`;
          data.jsonBody.results.forEach((item) => {
            //console.log(c);
            let months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];
            let endDate = new Date(item.endDate);
            endDate.setDate(endDate.getDate() + 1);
            
            let t = item.title.toLowerCase().replaceAll(" ","-").replace(/%/g, ' percent').replace(/\$([\d,]+(?:\.\d+)?)/g, '$1 dollars').replace(/\d+$/g, '') + "-" + item.id + "/" + c.name.toLowerCase().replaceAll(" ","-") + "-" + item.centerId;
            offerURL += t;
            html += `          
              <div class="plusOffer">
                <div class="plusHeart" onclick="deleteOfferFave('${item.id}',${c.id}, this)">              
                  <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_3341_26845)" style="filter: drop-shadow(0px 2px #ccc);">
                  <circle cx="29" cy="27" r="14" fill="white"/>
                  </g>
                  <g clip-path="url(#clip0_3341_26845)">
                  <path d="M36.6107 24.1342C36.3877 21.6805 34.651 19.9002 32.4774 19.9002C31.0294 19.9002 29.7035 20.6794 28.9574 21.9284C28.2181 20.6633 26.9466 19.8999 25.5217 19.8999C23.3485 19.8999 21.6114 21.6802 21.3888 24.1339C21.3711 24.2423 21.2989 24.8127 21.5186 25.7429C21.8352 27.0847 22.5666 28.3051 23.6331 29.2714L28.9539 34.1L34.366 29.2717C35.4326 28.3051 36.1639 27.085 36.4806 25.7429C36.7003 24.813 36.628 24.2426 36.6107 24.1342Z" fill="#9F005B"/>
                  </g>
                  <defs>
                  <filter id="filter0_d_3341_26845" x="0" y="0" width="58" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="2"/>
                  <feGaussianBlur stdDeviation="7.5"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3341_26845"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3341_26845" result="shape"/>
                  </filter>
                  <clipPath id="clip0_3341_26845">
                  <rect width="15.2727" height="15.2727" fill="white" transform="translate(21.3633 19.3635)"/>
                  </clipPath>
                  </defs>
                  </svg>
                </div>
                <a href="${offerURL}?source=shop-simon&utm_source=shopsimon&utm_medium=Offers&utm_campaign=shopsimon_Offers_SimonPlus">
                <div class='plusOfferImage'><img src='${item.logoUrl}' /></div>
                <div style="font-weight:bold;text-transform: uppercase;padding-top:5px;padding-bottom:4px">${item.tenant}</div>
                <div>${item.title}</div>
                <div>Valid till ${months[endDate.getMonth()]} ${endDate.getDate()}</div></a>
              </div>            
            `
          });
          html += `</div>`;      
           $("#fave-offer-list").show().html(html);
          $('#fave-offer-list').append(
                `<a href="${offerURL2}?source=shop-simon&utm_source=shopsimon&utm_medium=Offers&utm_campaign=shopsimon_Offers_SimonPlus"><div class="fave-btn btn-primary">
                  View All Offers
                </div>
                </a>`);
        }
        else
        {
          $(".fave-list-container").html(``);
          $('#fave-offer-list').html(``).append(
                `<div class="no-faves">You don't have any favorite offers for this center yet.</div>
                <a href="${offerURL2}?source=shop-simon&utm_source=shopsimon&utm_medium=Offers&utm_campaign=shopsimon_Offers_SimonPlus"><div class="fave-btn btn-primary">
                  View Offers
                </div>
                </a>`);
        }
      }); 
      
}
function deleteOfferFave(id,cid, e)
{
  ///
  window.simonPlus.delete(`/users/favorites/exclusive-offers/`,`{"id": ${id},"centerId": ${cid}}`)
    .then((data) => {
      if (data.ok)
      {
        $(e).parent().remove();
      }
    });
}
function favDraw(result,isRemove)
{  
  if (!isRemove)
  {
    $("#favNav").remove();         
    $(".fave-list-container").after('<div class="favNav" id="favNav"><ul class="favPagination" id="favPagingUL"></ul></div>');
  }
  else
  {
    if ($(".fave-list-item").length == 0)
      window.favCurrentPage--;
  }
  let arrlen = result.length;
  $("#favPagingUL").html("");
  let maxPerPage = 50;
  let prev = window.favCurrentPage - 1;
  let next = window.favCurrentPage + 1; 
  if (arrlen > maxPerPage)
  {
    setTimeout(function()
      { 
          if (prev > 0){
            $("#favPagingUL").append('<li><a onclick="favPageClick(' + prev + ')" id="pagePrev">«</a></li>'); 
          }
          $("#favPagingUL").append(doFavPaging(window.favCurrentPage,{range : 5, pages : Math.ceil(arrlen/maxPerPage)}));
          if (next < Math.ceil(arrlen/maxPerPage) + 1){
            $("#favPagingUL").append('<li><a onclick="favPageClick(' + next + ')" id="pageNext">»</a></li>');  
          }
      }, 100);  
  }
  let s = result.slice((window.favCurrentPage*maxPerPage)-maxPerPage,(window.favCurrentPage*maxPerPage));
  if (isRemove && $(".fave-list-item").length > 0)
  {
    s = s.slice(-1);
    if ($("#fave-item-" + s[0].productId).length == 0)
    {
      if (window.currentFavType == "product")
      {
        createFaveProductItem(s);
      }
      else if (window.currentFavType == "brand")
      {
        createFaveBrandItem(s);
      }
    }
  }
  else
  {
    if (window.currentFavType == "product")
    {
      createFaveProductItem(s);
    }
    else if (window.currentFavType == "brand")
    {
      createFaveBrandItem(s);
    }
  }  
}
function faveToggleProduct() {
  window.favCurrentPage = 1;  
  window.currentFavType = "product";
  fetchResults(false);  
  $(".favNav").show();
  $("#fave-list-container").show();
  $("#fave-brand-list-container").hide();
  $("#fave-offers-list-container").hide();
  document.querySelector(".fave-toggle-product").style.fontWeight = 'bolder';
  document.querySelector(".fave-toggle-product").style.textDecoration = 'underline';
  document.querySelector(".fave-toggle-product").style.textUnderlineOffset = '13px';
  document.querySelector(".fave-toggle-brand").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-brand").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-brand").style.textUnderlineOffset = 'unset';
  document.querySelector(".fave-toggle-offers").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-offers").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-offers").style.textUnderlineOffset = 'unset';
}
function faveToggleBrand() {
  window.favCurrentPage = 1;  
  window.currentFavType = "brand";
  if (!window.favBrandsLoaded)
    fetchResults(false);
  $(".favNav").hide();
  $("#fave-list-container").hide();
  $("#fave-brand-list-container").show();
  $("#fave-offers-list-container").hide();
  document.querySelector(".fave-toggle-product").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-product").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-product").style.textUnderlineOffset = 'unset';
  document.querySelector(".fave-toggle-offers").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-offers").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-offers").style.textUnderlineOffset = 'unset';
  document.querySelector(".fave-toggle-brand").style.fontWeight = 'bolder';
  document.querySelector(".fave-toggle-brand").style.textDecoration = 'underline';
  document.querySelector(".fave-toggle-brand").style.textUnderlineOffset = '13px';
}
function faveToggleOffers() {
  window.favCurrentPage = 1;  
  window.currentFavType = "offers";
  fetchResults(false);  
  $(".favNav").show();
  $("#fave-list-container").hide();
  $("#fave-brand-list-container").hide();
  $("#fave-offers-list-container").show();
  document.querySelector(".fave-toggle-product").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-product").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-product").style.textUnderlineOffset = 'unset';
  document.querySelector(".fave-toggle-brand").style.fontWeight = 'normal';
  document.querySelector(".fave-toggle-brand").style.textDecoration = 'unset';
  document.querySelector(".fave-toggle-brand").style.textUnderlineOffset = 'unset';
  document.querySelector(".fave-toggle-offers").style.fontWeight = 'bolder';
  document.querySelector(".fave-toggle-offers").style.textDecoration = 'underline';
  document.querySelector(".fave-toggle-offers").style.textUnderlineOffset = '13px';
}